<!-- 悬浮球公共组件 -->
<template>
	<div>
		<div ref="dragIcon" class="dragIcon" @touchstart.stop="handleTouchStart"
			@touchmove.prevent.stop="handleTouchMove($event)" @touchend.stop="handleTouchEnd"
			:style="{ left: left + 'px', top: top + 'px', width: itemWidth + 'px', height: itemHeight + 'px' }"
			v-if="isShow">
			<van-popover v-model="showPopover" theme="dark" trigger="click" :actions="actions" :placement="placValue"
				@select="onSelect">
				<template #reference>
					<van-icon name="wap-home-o" size="28" style="line-height:40px" />
				</template>
			</van-popover>
		</div>
	</div>
</template>

<script>
	export default {
		props: {
			text: {
				type: String,
				default: '球'
			},
			itemWidth: {
				type: Number,
				default: 40
			},
			itemHeight: {
				type: Number,
				default: 40
			}
		},
		data() {
			return {
				placValue: 'top-end',
				showPopover: false,
				actions: [{
					text: '注册',
					icon: 'contact'
				}, {
					text: '首页',
					icon: 'wap-home-o'
				}, {
					text: '医院动态',
					icon: 'eye-o'
				}, {
					text: '个人中心',
					icon: 'more-o'
				}],
				left: 0,
				top: 0,
				startToMove: false,
				isShow: true,
				timer: null,
				currentTop: null,
				clientW: document.documentElement.clientWidth, //视口宽
				clientH: document.documentElement.clientHeight //视口高
			};
		},
		created() {
			this.left = this.clientW - this.itemWidth - 20;
			this.top = this.clientH / 1.25 - this.itemHeight / 2;
		},
		mounted() {
			this.bindScrollEvent();
		},
		beforeDestroy() {
			// 记得销毁一些全局的的事件
			this.removeScrollEvent();
		},
		methods: {
			//选择气泡弹出框里的选项列表进行路由跳转
			onSelect(action) {
				console.log(action.text);
				if ('注册' == action.text) {
					this.$router.push({
						path: '/patientAdd'
					});
				}
				if ('首页' == action.text) {
					this.$router.push({
						path: '/index'
					});
				}
				if ('医院动态' == action.text) {
					this.$router.push({
						path: '/openModule'
					});
				}
				if ('个人中心' == action.text) {
					this.$router.push({
						path: '/personalCenter'
					});
				}
			},
			handleTouchStart() {
				if (!this.showPopover) {
					this.startToMove = true;
					this.$refs.dragIcon.style.transition = 'none';
				} else {
					this.startToMove = false;
				}
			},
			handleTouchMove(e) {
				const clientX = e.targetTouches[0].clientX; //手指相对视口的x
				const clientY = e.targetTouches[0].clientY; //手指相对视口的y
				const isInScreen = clientX <= this.clientW && clientX >= 0 && clientY <= this.clientH && clientY >= 0;
				if (this.startToMove && e.targetTouches.length === 1) {
					if (isInScreen) {
						this.left = clientX - this.itemWidth / 2;
						this.top = clientY - this.itemHeight / 2;
					}
				}
			},
			handleTouchEnd() {
				if (this.left < this.clientW / 2) {
					this.left = 20; //不让贴边 所以设置20没设置0
					this.handleIconY();
				} else {
					this.left = this.clientW - this.itemWidth - 20; //不让贴边 所以减20
					this.handleIconY();
				}
				this.$refs.dragIcon.style.transition = 'all .3s';
			},
			handleIconY() {
				if (this.top < 50) {
					this.top = 50; //不上帖上边所以设置为50 没设置0
				} else if (this.top + this.itemHeight > this.clientH) {
					this.top = this.clientH - this.itemHeight - 50; //不让帖下边所以减20
				}
				//根据左和高判断
				if (this.top > this.clientH / 2 && this.left == 20) {
					//左上
					this.placValue = 'top-start';
				} else if (this.top < this.clientH / 2 && this.left == 20) {
					//左下
					this.placValue = 'bottom-start';
				} else if (this.left != 20 && this.top > this.clientH / 2) {
					//右上
					this.placValue = 'top-end';
				} else {
					//右下
					this.placValue = 'bottom-end';
				}
			},
			bindScrollEvent() {
				window.addEventListener('scroll', this.handleScrollStart);
			},
			removeScrollEvent() {
				window.removeEventListener('scroll', this.handleScrollStart);
			},
			handleScrollStart() {
				this.isShow = false;
				this.timer && clearTimeout(this.timer);
				this.timer = setTimeout(() => {
					this.handleScrollEnd();
				}, 300);
				this.currentTop = document.documentElement.scrollTop || document.body.scrollTop;
			},
			handleScrollEnd() {
				this.scrollTop = document.documentElement.scrollTop || document.body.scrollTop;
				// 判断是否停止滚动的条件
				if (this.scrollTop == this.currentTop) {
					this.isShow = true;
				}
			}
		}
	};
</script>

<style scoped>
	.dragIcon {
		position: fixed;
		width: 40px;
		height: 40px;
		border-radius: 50%;
		background-color: #07c1607a;
		border: 2px solid #dcdee0;
		line-height: 40px;
		text-align: center;
		color: #fff;
	}

	.v-enter {
		opacity: 1;
	}

	.v-leave-to {
		opacity: 0;
	}

	.v-enter-active,
	.v-leave-active {
		transition: opacity 0.3s;
	}
</style>
